var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FBC02D",
  d: "m6 9.68 2.767 1.674a.665.665 0 0 0 .994-.72l-.734-3.147 2.447-2.12a.665.665 0 0 0-.38-1.167l-3.22-.273L6.614.954a.667.667 0 0 0-1.227 0L4.127 3.92l-3.22.274a.665.665 0 0 0-.38 1.167l2.447 2.12-.733 3.146a.665.665 0 0 0 .993.72z"
})));
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "Star.c3bc561f.svg";